import React, { useEffect } from 'react'
import "./collection.scss";
import Table from 'react-bootstrap/Table';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';
import axios from 'axios';
import Loader from '../../../utils/loader';
import Environment from '../../../utils/Enviroment';
import Dropdown from 'react-bootstrap/Dropdown';

const Collections = ({
  apply,
  save,
  featuredFilter,
  trendingFilter,
  publishedFilter,
  published,
  unpublishedFilter,
  clear,
  setApply,
  setSave,
  checkedCount,
  setCheckedCount,
  checkedItems,
  setCheckedItems,
  search,
  setLoading
}) => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const [collectionID, setCollectionID] = useState(null);
  const [bulkId, setBulkId] = useState([]);
  const [limit, setLimit] = useState(10);
  const handleShow = (id, Approved, Featured) => {
    console.log(id, "nft id......");

    setShow(true);
    setCollectionID(id);

    setStatuses({
      featured: Featured, // Corresponding to Featured status from API
      published: Approved, // Assuming "Approved" means "Published"
    });
  }

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);


  const [collectionsList, setCollections] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const [currentPage, setCurrentPage] = useState(collectionsList?.currentPage || 1);
  const [totalPages, setTotalPages] = useState(0);  // This will be updated based on API response
  const [totalItems, setTotalItems] = useState(0);  // This will be updated based on API response

  // Fetch NFTs with pagination and other parameters
  const fetchCollections = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Environment?.API_URL}admins/collection`, {
        params: {
          page: currentPage,  // Dynamically set the currentPage
          limit: limit,           // Adjust the limit as needed

          ...(search && { search: search }),
          ...(featuredFilter && { isFeatured: true }), // Add if featuredFilter is true
          ...(trendingFilter && { isTrending: true }), // Add if trendingFilter is true
          ...(publishedFilter && { isApproved: true }), // Add if publishedFilter is true
          ...(unpublishedFilter && { isApproved: false }), // Add if unpublishedFilter is true
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminAccessToken')}`,
          'Content-Type': 'application/json',
        },
      });

      console.log(response, "response from API...");
      setApply(false);

      setCollections(response.data);  // Assuming the response contains NFTs in 'data'
      setTotalPages(response.data.totalPages); // Assuming response has totalPages
      setTotalItems(response.data.totalItems); // Assuming response has totalItems

    } catch (err) {
      setError("Error fetching data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollections();
  }, [currentPage, limit, apply, clear, search]); // Re-run fetch when currentPage changes


  // Handle page change for pagination
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);  // Set the currentPage to the selected page
    }
  };

  // Generate page numbers dynamically
  const pageItems = [];
  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(i);  // Create an array of page numbers
  }


  const [statuses, setStatuses] = useState({
    featured: false,
    trending: false,
    published: false,
  });

  console.log(statuses, "statuses statuses statuses statuses");

  const handleCheckboxChange = (name) => {
    setStatuses(prevStatuses => ({
      ...prevStatuses,
      [name]: !prevStatuses[name],
    }));
  };


  const collectionSettingHandle = async () => {
    try {
      setLoading(true);

      const payload = bulkId.length > 0
        ? { ids: bulkId } // Pass an array of IDs if bulkId is not empty
        : { id: collectionID };  // Pass a single ID otherwise

      // Ensure statuses and published values are handled correctly
      const isApprovedValue = save == true ? published : statuses?.published;

      // Add the statuses to the payload
      const finalPayload = {
        ...payload,
        isFeatured: statuses?.featured,
        isTrending: statuses?.trending,
        isApproved: isApprovedValue, // Dynamically determine the approved value
      };
      const response = await axios.post(`${Environment?.API_URL}admins/collectionSetting`, finalPayload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('adminAccessToken')}`,
            'Content-Type': 'application/json',
          },
        });

      console.log(response, "response from API...");
      if (response) {
        fetchCollections();
        setCheckedItems([]);
        setSave(false);
        setBulkId([]);
        setCheckedItems({}); // Empty the checked items
        setCheckedCount(0);
        handleClose();
        handleShow2();
      }

    } catch (err) {
      setError("Error fetching data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (save == true) {

      collectionSettingHandle();
    }
  }, [save]);

  useEffect(() => {
    setBulkId([]);
    setCheckedItems({}); // Empty the checked items
    setCheckedCount(0);
  }, []);


  const handleCheckboxChange2 = (id) => {
    console.log("clicked");

    setCheckedItems((prev) => {
      const updated = { ...prev };

      if (updated[id]) {
        // If the ID is already checked, remove it
        delete updated[id];
        setBulkId((prevBulkId) => prevBulkId.filter((bulkId) => bulkId !== id)); // Remove ID from bulk IDs
      } else {
        // Otherwise, add the ID as checked
        updated[id] = true;
        setBulkId((prevBulkId) => [...prevBulkId, id]); // Add ID to bulk IDs
      }

      console.log(updated, "updated");

      const count = Object.keys(updated).length; // Count the checked items
      setCheckedCount(count); // Update the checked count
      return updated;
    });
  };

  return (
    <>
      {/* {!loading && <Loader />} */}

      <div className='table_div'>
        <Table responsive className='mytablemain'>
          <thead>
            <tr>
              <th>
                <div className='tdclass'>
                  <div className='leftsidediv'>

                    Item
                  </div>
                </div>

              </th>

              <th >Creator</th>
              <th>TOTAL ITEMS</th>
              <th >TOTAL VOLUME</th>
              <th>SHOW ON HOME</th>
              <th >PUBLISHED</th>
              <th>Action</th>
              {/* <th >Action</th> */}
            </tr>
          </thead>
          <tbody>
            {
              collectionsList?.data?.length > 0 ?
                collectionsList?.data?.map((item, index) => {
                  const convertedURL = item?.logoUrl?.replace("ipfs://", "https://ipfs.io/ipfs/");
                  const isChecked = !!checkedItems[item?._id];
                  return (
                    <tr key={index}>
                      <td>

                        <div className='tdclass'>
                          <div className='leftsidediv'>
                            <div class="example checkboxesnew">
                              <label class="checkbox-button">
                                {/* <input type="checkbox" class="checkbox-button__input" id="choice1-1" name="choice1" /> */}
                                <input
                                  type="checkbox"
                                  className="checkbox-button__input"
                                  id={`choice-${item?._id}`}
                                  name={`category-${item?._id}`}
                                  checked={isChecked}
                                  onChange={() => handleCheckboxChange2(item?._id)}

                                />
                                <span class="checkbox-button__control"></span>
                              </label>

                            </div>
                            <div className='imgtag'>
                              <img src={item?.logoUrl ? item?.logoUrl : convertedURL} className='imgnew' />
                            </div>
                          </div>

                          <div>
                            <h1>{item?.name}</h1>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className='tdtwos'>
                          <div className='imgsecond'>
                            <img className='imginnner' src={item?.creatorDetails?.picture} />
                          </div>
                          <h1>{item?.creatorDetails?.name}</h1>
                        </div>
                      </td>
                      <td><h1>{item?.totalQuantity?.toLocaleString()}</h1></td>
                      <td><h1>{item?.totalVolume?.toLocaleString()}</h1></td>
                      <td>
                        {
                          item?.isFeatured == true ?
                            <h1>YES</h1>
                            :
                            <h3>NO</h3>
                        }
                      </td>
                      <td>
                        {
                          item?.isApproved == true ?
                            <h1>YES</h1>
                            :
                            <h3>NO</h3>
                        }
                      </td>

                      <td onClick={() => handleShow(item?._id, item?.isApproved, item?.isFeatured,)}>
                        <button>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M7.00003 4.00003C6.40668 4.00003 5.82666 4.17598 5.33332 4.50562C4.83997 4.83526 4.45545 5.3038 4.22839 5.85198C4.00133 6.40016 3.94192 7.00336 4.05767 7.5853C4.17343 8.16724 4.45915 8.70179 4.87871 9.12135C5.29827 9.54091 5.83281 9.82663 6.41476 9.94238C6.9967 10.0581 7.5999 9.99873 8.14808 9.77167C8.69626 9.5446 9.16479 9.16009 9.49444 8.66674C9.82408 8.17339 10 7.59337 10 7.00003C9.9992 6.20463 9.68286 5.44205 9.12043 4.87962C8.558 4.31719 7.79542 4.00086 7.00003 4.00003ZM7.00003 9.00003C6.60447 9.00003 6.21779 8.88273 5.88889 8.66297C5.55999 8.4432 5.30364 8.13085 5.15227 7.76539C5.00089 7.39994 4.96129 6.99781 5.03846 6.60985C5.11563 6.22189 5.30611 5.86552 5.58581 5.58581C5.86552 5.30611 6.22189 5.11563 6.60985 5.03846C6.99781 4.96129 7.39994 5.00089 7.76539 5.15227C8.13085 5.30364 8.4432 5.55999 8.66297 5.88889C8.88273 6.21779 9.00003 6.60447 9.00003 7.00003C9.00003 7.53046 8.78931 8.03917 8.41424 8.41424C8.03917 8.78931 7.53046 9.00003 7.00003 9.00003ZM12.5 7.13503C12.5025 7.04503 12.5025 6.95503 12.5 6.86503L13.4325 5.70003C13.4814 5.63886 13.5153 5.56706 13.5313 5.49042C13.5474 5.41378 13.5452 5.33443 13.525 5.25878C13.3722 4.68415 13.1435 4.13243 12.845 3.61815C12.8059 3.55085 12.7517 3.4936 12.6866 3.45096C12.6215 3.40832 12.5473 3.38146 12.47 3.37253L10.9875 3.20753C10.9259 3.14253 10.8634 3.08003 10.8 3.02003L10.625 1.53378C10.616 1.45641 10.5891 1.38222 10.5463 1.31711C10.5036 1.252 10.4462 1.19779 10.3788 1.15878C9.8643 0.86087 9.31263 0.632425 8.73815 0.479404C8.66245 0.459277 8.58308 0.457218 8.50643 0.473394C8.42979 0.489569 8.35802 0.523527 8.2969 0.572529L7.13503 1.50003C7.04503 1.50003 6.95503 1.50003 6.86503 1.50003L5.70003 0.569404C5.63886 0.520509 5.56706 0.486665 5.49042 0.470598C5.41378 0.454531 5.33443 0.456691 5.25878 0.476903C4.68425 0.630045 4.13256 0.858705 3.61815 1.1569C3.55085 1.19598 3.4936 1.25023 3.45096 1.31533C3.40832 1.38044 3.38146 1.45459 3.37253 1.5319L3.20753 3.0169C3.14253 3.07899 3.08003 3.14149 3.02003 3.2044L1.53378 3.37503C1.45641 3.38403 1.38222 3.41098 1.31711 3.45373C1.252 3.49649 1.19779 3.55386 1.15878 3.62128C0.86087 4.13576 0.632425 4.68743 0.479404 5.2619C0.459277 5.33761 0.457218 5.41698 0.473394 5.49362C0.489569 5.57027 0.523527 5.64204 0.572529 5.70315L1.50003 6.86503C1.50003 6.95503 1.50003 7.04503 1.50003 7.13503L0.569404 8.30003C0.520509 8.3612 0.486665 8.43299 0.470598 8.50963C0.454531 8.58628 0.456691 8.66562 0.476903 8.74128C0.629772 9.3159 0.858447 9.86762 1.1569 10.3819C1.19598 10.4492 1.25023 10.5065 1.31533 10.5491C1.38044 10.5917 1.45459 10.6186 1.5319 10.6275L3.0144 10.7925C3.07649 10.8575 3.13899 10.92 3.2019 10.98L3.37503 12.4663C3.38403 12.5436 3.41098 12.6178 3.45373 12.6829C3.49649 12.7481 3.55386 12.8023 3.62128 12.8413C4.13576 13.1392 4.68743 13.3676 5.2619 13.5207C5.33761 13.5408 5.41698 13.5428 5.49362 13.5267C5.57027 13.5105 5.64204 13.4765 5.70315 13.4275L6.86503 12.5C6.95503 12.5025 7.04503 12.5025 7.13503 12.5L8.30003 13.4325C8.3612 13.4814 8.43299 13.5153 8.50963 13.5313C8.58628 13.5474 8.66562 13.5452 8.74128 13.525C9.3159 13.3722 9.86762 13.1435 10.3819 12.845C10.4492 12.8059 10.5065 12.7517 10.5491 12.6866C10.5917 12.6215 10.6186 12.5473 10.6275 12.47L10.7925 10.9875C10.8575 10.9259 10.92 10.8634 10.98 10.8L12.4663 10.625C12.5436 10.616 12.6178 10.5891 12.6829 10.5463C12.7481 10.5036 12.8023 10.4462 12.8413 10.3788C13.1392 9.8643 13.3676 9.31263 13.5207 8.73815C13.5408 8.66245 13.5428 8.58308 13.5267 8.50643C13.5105 8.42979 13.4765 8.35802 13.4275 8.2969L12.5 7.13503ZM11.4938 6.72878C11.5044 6.90946 11.5044 7.0906 11.4938 7.27128C11.4863 7.39498 11.5251 7.51703 11.6025 7.61378L12.4894 8.7219C12.3876 9.04532 12.2573 9.35905 12.1 9.6594L10.6875 9.8194C10.5645 9.83306 10.4509 9.89185 10.3688 9.9844C10.2485 10.1197 10.1203 10.2478 9.98503 10.3682C9.89247 10.4503 9.83368 10.5639 9.82003 10.6869L9.66315 12.0982C9.36284 12.2555 9.0491 12.3858 8.72565 12.4875L7.6169 11.6007C7.52818 11.5298 7.41797 11.4912 7.3044 11.4913H7.2744C7.09373 11.5019 6.91258 11.5019 6.7319 11.4913C6.6082 11.4838 6.48615 11.5226 6.3894 11.6L5.27815 12.4875C4.95474 12.3858 4.641 12.2555 4.34065 12.0982L4.18065 10.6875C4.167 10.5645 4.10821 10.4509 4.01565 10.3688C3.88035 10.2485 3.75221 10.1203 3.6319 9.98503C3.54974 9.89247 3.43616 9.83368 3.31315 9.82003L1.9019 9.66253C1.74452 9.36221 1.61422 9.04847 1.51253 8.72503L2.3994 7.61628C2.47684 7.51953 2.5156 7.39748 2.50815 7.27378C2.49753 7.0931 2.49753 6.91195 2.50815 6.73128C2.5156 6.60758 2.47684 6.48552 2.3994 6.38878L1.51253 5.27815C1.61429 4.95474 1.7446 4.641 1.9019 4.34065L3.31253 4.18065C3.43554 4.167 3.54911 4.10821 3.63128 4.01565C3.75158 3.88035 3.87972 3.75221 4.01503 3.6319C4.10795 3.54968 4.16698 3.43585 4.18065 3.31253L4.33753 1.9019C4.63784 1.74452 4.95158 1.61422 5.27503 1.51253L6.38378 2.3994C6.48052 2.47684 6.60258 2.5156 6.72628 2.50815C6.90696 2.49753 7.0881 2.49753 7.26878 2.50815C7.39248 2.5156 7.51453 2.47684 7.61128 2.3994L8.7219 1.51253C9.04532 1.61429 9.35905 1.7446 9.6594 1.9019L9.8194 3.31253C9.83306 3.43554 9.89185 3.54911 9.9844 3.63128C10.1197 3.75158 10.2478 3.87972 10.3682 4.01503C10.4503 4.10758 10.5639 4.16637 10.6869 4.18003L12.0982 4.3369C12.2555 4.63722 12.3858 4.95096 12.4875 5.2744L11.6007 6.38315C11.5225 6.48071 11.4837 6.60403 11.4919 6.72878H11.4938Z" fill="#424242" />
                          </svg>
                          Settings
                        </button>
                      </td>
                    </tr>
                  );
                })
                :
                <tr>
                  <p>No Data found!</p>
                </tr>
            }
          </tbody>
        </Table>

        <div className="pagi_main">
          <div className="paginationdiv">
            <h4>
              SHOWING {(currentPage - 1) * limit + 1}-{Math.min(currentPage * limit, totalItems)} OF {totalItems}
            </h4>
            <div>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  {limit} <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <path d="M8.5 3.54166L8.5 13.4583M8.5 13.4583L4.25 9.20832M8.5 13.4583L12.75 9.20832" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className='dropdonwmainss'>
                    <p onClick={() => setLimit(10)}>
                      10 {limit === 10 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                    <p onClick={() => setLimit(30)}>
                      30 {limit === 30 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                    <p onClick={() => setLimit(50)}>
                      50 {limit === 50 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                    <p onClick={() => setLimit(100)}>
                      100 {limit === 100 && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                          <path d="M2 5.19997L4.54531 8L10 2" stroke="#724EF7" strokeWidth="1.5" strokeLinecap="square" />
                        </svg>
                      )}
                    </p>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <Pagination className="pageeee">
            {/* Previous Page Button */}
            {
              totalPages > 1 &&
              <div className='rightsideee'>
                <img
                  src="\assets\leftarrow.svg"
                  alt="previous"
                  onClick={() => handlePageChange(currentPage - 1)}
                  style={{ cursor: 'pointer' }}
                  className='imggggggright'
                />
              </div>
            }

            {/* Ellipsis for skipped pages */}
            {currentPage > 5 && <Pagination.Ellipsis />}

            {/* Dynamic Page Numbers */}
            {pageItems.slice(Math.max(currentPage - 3, 0), Math.min(currentPage + 2, totalPages - 1)).map((page) => (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            ))}

            {/* Ellipsis for skipped pages */}
            {currentPage < totalPages - 2 && <Pagination.Ellipsis />}

            {/* Last Page Button */}
            {totalPages > 1 && (
              <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Pagination.Item>
            )}

            {/* Next Page Button */}
            {
              totalPages > 1 &&
              <div className='rightsideee'>
                <img
                  src="\assets\righarrow.svg"
                  alt="next"
                  onClick={() => handlePageChange(currentPage + 1)}
                  style={{ cursor: 'pointer' }}
                  className='imggggggright'
                />
              </div>
            }

          </Pagination>
        </div>
      </div>



      <Modal show={show} onHide={handleClose} centered className='modal1'>
        <Modal.Header closeButton>
          <Modal.Title>Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='swtich1_head'>
            <div className='switch11'>
              <h1>Show on Homepage</h1>
              <div>
                <label class="switch1">
                  <input type="checkbox"
                    checked={statuses.featured}
                    onChange={() => handleCheckboxChange('featured')} // Toggle specific checkbox 
                  />
                  <span class="slider round"></span>
                </label>
              </div>

            </div>
            <div className='switch111 newstitch'>
              <h1>Published</h1>
              <div>
                <label class="switch1">
                  <input
                    type="checkbox"
                    checked={statuses.published}
                    onChange={() => handleCheckboxChange('published')} // Toggle specific checkbox
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className='buttton_div'>
            <Button className='cancel' variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button className='save' variant="primary"
              onClick={() => {
                // handleClose();
                // handleShow2();
                collectionSettingHandle();
              }}>
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>



      <Modal show={show2} onHide={handleClose2} centered className='modal1'>
        <Modal.Body>
          <div className='modal2'>
            <svg xmlns="http://www.w3.org/2000/svg" width="66" height="67" viewBox="0 0 66 67" fill="none">
              <rect width="66" height="66" transform="translate(0 0.669922)" fill="#54EB37" />
              <path d="M27.9554 47.7961L15.8466 35.6878L19.8825 31.6519L27.9554 39.7243L46.1175 21.5616L50.1534 25.5975L27.9554 47.7961Z" fill="black" />
            </svg>
            <h2>Changes saved successfully</h2>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='buttton_div'>
            <Button className='save' variant="primary" onClick={handleClose2}>
              OKAY
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Collections